<template>
  <div class="profile-table-wrapper profile-form-wrapper">
    <div class="table-container">
      <table>
        <thead>
          <tr>
            <td>ID</td>
            <td>Date</td>
            <td>Skin name</td>
            <td>Status</td>
            <td>Total</td>
            <td>Details</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, i) in offers" :key="i">
            <td>{{ item.id }}</td>
            <td>{{ formatDate(item.date_time) }}</td>
            <td>{{ item.title }}</td>
            <td :class="statusClass(item.status)">
              <span class="status">{{ formatStatus(item.status) }}</span>
            </td>
            <td class="desc">
              <b>{{ item.service_price || item.user_price }} {{ item.currency }}</b>
            </td>
            <td>
              <a
                v-if="item.status != 'ready_for_payout'"
                class="offer-modal-open desc link"
                @click="$emit('viewDetails', item)"
              >
                <b>View</b>
              </a>
              <a
                class="offer-modal-open desc link"
                v-if="item.status == 'ready_for_payout'"
                @click="openAcceptOffer(item)"
              >
                <b>Withdraw</b>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="pagination" id="pagination"></div>
  </div>
</template>

<script>
export default {
  name: "OffersTable",
  props: {
    offers: { type: Array, required: true },
    formatDate: { type: Function, required: true },
  },
  methods: {
    formatStatus(status) {
      if (!status) return "";
      return status.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
    },
    statusClass(status) {
      switch (status) {
        case "approved":
        case "ready_for_payout":
          return "green";
        case "declined_by_user":
        case "declined_by_service":
          return "red";
        default:
          return "";
      }
    },
    openAcceptOffer(item) {
      if (!item || !item.id) {
        this.$emit('error', 'Invalid offer data. Missing required ID.');
        return;
      }
      this.$emit('acceptOffer', item);
    },
  },
};
</script>
